import * as z from "zod/v4";

export const releaseAllHolds = {
  name: "releaseAllHolds" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({ failedGroupIds: z.array(z.string()) }),
};
